$(() => {
  if ($('#pending-default-pdfs').length) {
    pollJobStatus(
      $('#pending-default-pdfs').data('job-id'),
      'add_default_pdfs',
    );
  }

  function pollJobStatus(jobId, path) {
    new HandshqApp.Polling({
      url: '/jobs/status/' + jobId,
      responseCheck(response) {
        return response.status === 'completed';
      },
      successCallback(response) {
        $.ajax({
          data: response,
          type: 'GET',
          url: '/projects/' + response.project_id + '/' + path,
        });
      },
      failureCallback(_response) {},
    }).start();
  }
});
